import React, { useEffect, useState } from "react";
import {
  Card,
  Skeleton,
  Typography,
  Avatar,
  Row,
  Col,
  Tag,
  Divider,
  Alert,
} from "antd";
import "./NotificationsStyles.css";
import {
  getFullApplicationName,
  ModuleColor,
} from "../../../../components/icons/ApplicationColor";
import { MailOutlined, UserOutlined } from "@ant-design/icons";
import {
  NotificationEmailType,
  NotificationSubType,
} from "./NotificationTypeHelper";
import moment from "moment";
import axiosInstance from "../../../../api/Axios";
import { useSelector, useDispatch } from "react-redux";
import { setNotificationLoader } from "../../../../store/slices/notificationSlice";

const { Text } = Typography;
const NotificationDetails = ({ selectedNotificationID, origin }) => {
  const [selectedData, setSelectedData] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const notificationsLoader = useSelector(
    (state) => state.notificationList.loading
  );
  console.log(selectedNotificationID);
  const getIdData = async () => {
    setLoading(true);
    const passUrl = `/notificationevent/?id=${selectedNotificationID}`;
    try {
      const res = await axiosInstance.get(passUrl);
      setSelectedData(res?.data?.[0]);
      setLoading(false);
      dispatch(setNotificationLoader(false));
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (selectedNotificationID) {
      getIdData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedNotificationID, notificationsLoader]);
  if (!selectedNotificationID) {
    return (
      <Card style={{ width: "70%" }} hoverable>
        <Alert
          message="Notification Selection Needed"
          description="You need to select a notification from the list to view its complete details, including the message content, timestamps, and other related information."
          type="info"
          showIcon
        />
      </Card>
    );
  }
  const notificationHelper = (type) => {
    switch (type) {
      case "Subscription Remainder":
      case "subscription":
        return (
          <NotificationSubType
            selectedNotification={selectedData}
            origin={origin}
          />
        );
      case "Event":
      case "Email":
      case "email":
        return (
          <NotificationEmailType
            selectedNotification={selectedData}
            origin={origin}
          />
        );
      default:
        <NotificationEmailType
          selectedNotification={selectedData}
          origin={origin}
        />;
    }
  };
  return (
    <Card
      hoverable
      headStyle={{
        // backgroundColor: "#353935",
        padding: "6.5px",
      }}
      bodyStyle={{ padding: 20 }}
      title={
        <span
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "black",
            fontFamily: "Poppins",
            fontWeight: 500,
            fontSize: "16px",
            textAlign: "center",
            width: "100%",
          }}
        >
          SELECTED NOTIFICATION DETAILS
        </span>
      }
      className="smallCard"
      style={{ width: "95%", height: "100%" }}
    >
      <Skeleton
        loading={loading}
        active
        avatar
        paragraph={{
          rows: 12,
        }}
        style={{ width: "100%", height: "100%" }}
      >
        <div style={{ margin: "20px" }}>
          <Row gutter={16} style={{ marginBottom: "17.5px" }}>
            <Col span={12}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Text className="text-name-styles-headings">Type :</Text>
                <Text className="text-name-styles">{selectedData?.type}</Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Text className="text-name-styles-headings">Module :</Text>
                <Tag
                  color={ModuleColor(selectedData?.application)}
                  title={selectedData?.application}
                  style={{ marginRight: "8px" }}
                  size="small"
                >
                  <span
                    style={{
                      color: "black",
                      fontWeight: "500",
                    }}
                  >
                    {getFullApplicationName(
                      selectedData?.application
                    )?.toUpperCase()}
                  </span>
                </Tag>
              </div>
            </Col>
          </Row>
          <Row gutter={16} style={{ marginBottom: "17.5px" }}>
            <Col span={12}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Text className="text-name-styles-headings">Sent By :</Text>
                <Avatar
                  src={
                    selectedData?.sentBy?.image ||
                    "https://cdn-icons-png.flaticon.com/512/1828/1828970.png"
                  }
                />
                <Text className="text-name-styles">
                  {selectedData?.sentBy?.name}
                </Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Text className="text-name-styles-headings">Received By :</Text>

                <Avatar
                  style={{
                    background:
                      Array.isArray(selectedData?.receivedBy) &&
                      selectedData?.receivedBy.length > 1
                        ? "lightblue"
                        : "",
                  }}
                  src={
                    Array.isArray(selectedData?.receivedBy) &&
                    selectedData?.receivedBy.length === 1 &&
                    selectedData?.receivedBy[0]?.image
                      ? selectedData.receivedBy[0].image
                      : null
                  }
                  icon={
                    Array.isArray(selectedData?.receivedBy) &&
                    selectedData?.receivedBy.length > 1 ? (
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: "500",
                          color: "black",
                        }}
                      >
                        {selectedData?.receivedBy.length}
                      </span>
                    ) : (
                      Array.isArray(selectedData?.receivedBy) &&
                      selectedData?.receivedBy.length === 1 &&
                      !selectedData?.receivedBy[0]?.image && <UserOutlined />
                    )
                  }
                  alt={
                    Array.isArray(selectedData?.receivedBy) &&
                    selectedData?.receivedBy.length === 1
                      ? selectedData?.receivedBy[0]?.name
                      : "participants"
                  }
                />
                <Text className="text-name-styles">
                  {Array.isArray(selectedData?.receivedBy) &&
                    (selectedData.receivedBy.length === 1
                      ? selectedData.receivedBy[0]?.name
                      : `${selectedData.receivedBy[0]?.name} and ${
                          selectedData.receivedBy.length - 1
                        } others`)}
                </Text>
              </div>
            </Col>
          </Row>

          <Row gutter={16} style={{ marginBottom: "20px" }}>
            <Col span={12}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Text className="text-name-styles-headings">Time :</Text>
                <Text className="text-name-styles">
                  {moment(selectedData?.timestamp).format("MMM DD YYYY h:mm A")}
                </Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Text className="text-name-styles-headings">
                  Delivery Method :
                </Text>
                <Text className="text-name-styles">
                  {selectedData?.method?.toUpperCase() || "System"}
                </Text>
                <MailOutlined style={{ paddingLeft: "2.5px" }} />
              </div>
            </Col>
          </Row>
          <Divider />
          {notificationHelper(selectedData?.category)}
        </div>
      </Skeleton>
    </Card>
  );
};

export default NotificationDetails;
